import { getApiClient } from 'adapter/out/client/apiClient';
import { ReportFilters } from 'domain/entity/reportFilters';

const readReportFiltersApiClient = getApiClient(() => `dashboards/reports/filters`, ReportFilters);

export default readReportFiltersApiClient;
